import React, { useState } from "react" ;

import "../../styles/UI/formInput.scss";

const FormTextArea = (props) => {

    const { placeholder, ...inputProps } = props;

    const [focusDirty, setFocusDirty] = useState("");

    const handleFocus = (e) => {
        e.target.value ? setFocusDirty("dirty") : setFocusDirty("");
    }
// console.log(props.value);
    return (
        <label 
            // className="custom-field"
            className={props.value ?
                        "custom-field custom-field_focus"
                        :
                        "custom-field"
                        }
        >
            <textarea className={focusDirty} onBlur={handleFocus} {...inputProps}></textarea>
            <span className="placeholder">{placeholder}</span>
            <span className="outline"></span>
        </label>
    );
}

export default FormTextArea;
